import type Phaser from "phaser";

export const CLOSE_BUTTON_HIT_AREA_SCALE = 1.5;

export interface CloseButtonHitAreaRect {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

export function expandedCloseButtonHitArea(
  width: number,
  height: number,
  scale = CLOSE_BUTTON_HIT_AREA_SCALE,
): CloseButtonHitAreaRect {
  const baseW = Math.max(1, width);
  const baseH = Math.max(1, height);
  const safeScale = Math.max(1, scale);
  const hitW = baseW * safeScale;
  const hitH = baseH * safeScale;
  return {
    x: (baseW - hitW) / 2,
    y: (baseH - hitH) / 2,
    width: hitW,
    height: hitH,
  };
}

export function closeButtonHitAreaContains(
  hitArea: CloseButtonHitAreaRect,
  x: number,
  y: number,
): boolean {
  return x >= hitArea.x && x <= hitArea.x + hitArea.width && y >= hitArea.y && y <= hitArea.y + hitArea.height;
}

export function setExpandedCloseButtonHitArea(
  text: Phaser.GameObjects.Text,
  scale = CLOSE_BUTTON_HIT_AREA_SCALE,
): Phaser.GameObjects.Text {
  const hit = expandedCloseButtonHitArea(text.width || text.displayWidth, text.height || text.displayHeight, scale);
  return text.setInteractive({
    useHandCursor: true,
    hitArea: hit,
    hitAreaCallback: closeButtonHitAreaContains,
  });
}
